import { CircularProgress } from '@ori-ui/mui';
import { useTranslation } from 'react-i18next';

import { TranslationKeys } from '../../models';
import { Dialog } from '../Dialog';
import type { LoadingProps } from './types';

export const Loading = ({ show = false }: LoadingProps) => {
  const [translate] = useTranslation();

  return (
    <Dialog
      hideCloseButton
      open={show}
      header={translate(TranslationKeys.FindingProduct)}
    >
      <CircularProgress color="primary" />
    </Dialog>
  );
};
